'use client';

import { useFeatureFlag } from '@/feature-flags/hooks/use-feature-flag.hook';
import { useIsGreaterThan } from '@/hooks/use-is-greather-than.hook';

const COMPACT_SLOTS_PER_COLUMN = 3;

export interface UseExpandedSlotsGridResult {
  showsExpandedGrid: boolean;
  isCompact: boolean;
  slotsPerColumn: number | undefined;
  gridClassName: string;
  variant: 'A' | 'B';
}

export function useExpandedSlotsGrid(): UseExpandedSlotsGridResult {
  const { value: showsExpandedGrid } = useFeatureFlag('shouldShowExpandedGrid');
  const isWideViewport = useIsGreaterThan('xl');
  const isCompact = showsExpandedGrid && !isWideViewport;

  return {
    showsExpandedGrid,
    isCompact,
    slotsPerColumn: isCompact ? COMPACT_SLOTS_PER_COLUMN : undefined,
    gridClassName: showsExpandedGrid ? 'flex' : 'hidden xl:flex',
    variant: showsExpandedGrid ? 'B' : 'A',
  };
}
